export const blobToJsonAsync = async (response: Blob) => {
  const blobText = await response.text();
  return JSON.parse(blobText);
};
